import React from 'react'

function V2NotFoundPage() {
    return (
        <div className="v2-not-found-page">
            <div className="v2-not-found-lines" />
            <main className="v2-not-found-card">
                <img className="v2-not-found-logo" src="/resources/s50.png" alt="Split 50-50" />
                <p className="v2-not-found-eyebrow">Event not found</p>
                <h1>This Split 50-50 event is not available.</h1>
                <p>
                    The event link may be incorrect, expired, or not live yet. Please check the URL or contact the organisation running the raffle.
                </p>
                <a href="https://s50.events" className="v2-not-found-action">Go to s50.events</a>
            </main>
        </div>
    )
}

export default V2NotFoundPage
